import React, { ButtonHTMLAttributes, FC } from "react";
import cx from "classnames";

import styles from "./styles.module.scss";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  mode: "text" | "filled" | "outlined";
  children: string;
}

const Button: FC<ButtonProps> = ({ children, mode = "text", ...props }) => {
  return (
    <button
      {...props}
      className={cx(styles.button, styles[`button_${mode}`], props.className)}
    >
      {children}
    </button>
  );
};

export default Button;
